// extracted by mini-css-extract-plugin
export default {"container":"Fr1_3_99F5HeBMaoqHrw"};